"use client"
/* eslint-disable @next/next/no-img-element */
import React, { useEffect } from "react"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import Menu from "@mui/material/Menu"
import Avatar from "@mui/material/Avatar"
import Tooltip from "@mui/material/Tooltip"
import MenuItem from "@mui/material/MenuItem"
// Icon Imports
import homeIcon from "../../utils/assets/images/homeIcon.png"
import historyIcon from "../../utils/assets/images/historyIcon.png"
import logoutIcon from "../../utils/assets/images/logoutIcon.png"
import shoppingBagIcon from "../../utils/assets/images/shoppingBagIcon.png"
import Link from "next/link"
import Image from "next/image"
import { ROUTES } from "@/utils/constants/routes/routes"
import LogoutIcon from "@mui/icons-material/Logout"
import HomeIcon from "@mui/icons-material/Home"
import { COLORS } from "@/theme/localTheme"
import { useLocalStorage, useReadLocalStorage } from "usehooks-ts"
import { ToastContainer, toast } from "react-toastify"
import { redirect } from "next/navigation"
import { HPlusMobiledata } from "@mui/icons-material"

type StaticImageData = {
  src?: string
  height: number
  width: number
  blurDataURL?: string
}

function AvatarMenu({ userData }: { userData: any }) {
  const accessToken = useReadLocalStorage("accessToken")
  const userDetails = useReadLocalStorage("userData")

  const [removeToken, setRemoveToken] = useLocalStorage("accessToken", accessToken)

  const [removeUserData, setRemoveUserData] = useLocalStorage("userData", userDetails)

  const handleLogout = () => {
    setRemoveToken(null)
    setRemoveUserData(null)
    redirect("/login")
  }
  useEffect(() => {
    if (removeToken === null) {
      toast.success("Logged Out Successfully", {
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
  }, [removeToken])

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }
  const getInitials = (firstName: string, lastName: string) => {
    const firstInitial = firstName ? firstName[0].toUpperCase() : ""
    const lastInitial = lastName ? lastName[0].toUpperCase() : ""
    return `${firstInitial}${lastInitial}`
  }
  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            sx={{ height: "2.5rem", width: "2.5rem" }}
            alt="Profile Avatar"
            src={`https://ui-avatars.com/api/?background=1B920A&color=fff&name=${userData?.Full_Name}`}
          />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{
          mt: "2rem",
          "& .MuiMenu-list": {
            p: 0,
          },
          "& .MuiMenuItem-root:hover": {
            backgroundColor: "#272D24",
            filter: " invert(20%)",
          },
        }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem
          onClick={handleCloseUserMenu}
          sx={{
            backgroundColor: "#272D24",
            p: "0.75rem",
            borderBottom: "1px solid #636363",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              backgroundColor: "#272D24",
            }}
          >
            <Link href={`/user-profile`} style={{ display: "flex" }}>
              <HomeIcon style={{ color: COLORS?.adminAppTextPrimary }} />
              <Typography
                sx={{
                  ml: "1rem",
                  fontWeight: "500",
                  color: COLORS?.adminAppTextPrimary,
                }}
              >
                My Profile
              </Typography>
            </Link>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={handleCloseUserMenu}
          sx={{
            backgroundColor: "#272D24",
            p: "0.75rem",
            borderBottom: "1px solid #636363",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              backgroundColor: "#272D24",
            }}
            onClick={handleLogout}
          >
            <Link href={"#"} style={{ display: "flex" }}>
              <LogoutIcon style={{ color: COLORS?.adminAppTextPrimary }} />
              <Typography
                sx={{
                  ml: "1rem",
                  fontWeight: "500",
                  color: COLORS?.adminAppTextPrimary,
                }}
              >
                Logout
              </Typography>
            </Link>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  )
}
export default AvatarMenu
